import api, { authService } from './api';

export const emailsService = {
  listEmails: async ({ q, limit = 5000 } = {}) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/emails', {
        params: { q, limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch emails',
      };
    }
  },

  createEmail: async (payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post('/emails', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to create email',
      };
    }
  },

  updateEmail: async (userId, payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.patch(`/emails/${encodeURIComponent(userId)}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to update email',
      };
    }
  },
};
